export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5646.7e3b7cae.jpg";